import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PChipComponent } from './p-chip.component';
import { PIconModule } from '@panaya/ui/p-icon';
import { PButtonModule } from '@panaya/ui/p-button';

@NgModule({
    declarations: [PChipComponent],
    imports: [CommonModule, PIconModule, PButtonModule],
    exports: [PChipComponent]
})
export class PChipModule {}
